
/* Summum Fitness — confirmation après ajout au panier */
(function () {
  var timers = new WeakMap();

  document.addEventListener('ajaxProduct:added', function (event) {
    var button = event.detail && event.detail.addToCartBtn;

    if (!button) return;

    var textElement = button.querySelector('[data-add-to-cart-text]');
    if (!textElement) return;

    var originalText =
      textElement.getAttribute('data-default-text') ||
      textElement.textContent.trim();

    if (timers.has(button)) {
      clearTimeout(timers.get(button));
    }

    textElement.textContent = 'Added to cart ✓';
    button.classList.remove('cart-added-success');

    // Redémarrer l'animation
    void button.offsetWidth;
    button.classList.add('cart-added-success');

    var timer = setTimeout(function () {
      textElement.textContent = originalText;
      button.classList.remove('cart-added-success');
      timers.delete(button);
    }, 2000);

    timers.set(button, timer);
  });
})();
